import type { InjectionKey, Ref } from 'vue'

export interface OenUiAlert {
  id: string
}

export const OenUiAlertKey: InjectionKey<Ref<OenUiAlert>> = Symbol('OenUiAlert')
